export const APP_CONFIG = {
  appName: import.meta.env.VITE_APP_NAME ?? "OranAI Prompt",
  /** API 网关前缀（Vite proxy / Nginx 反代统一去除该前缀） */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "/api",
  apiTimeout: Number(import.meta.env.VITE_API_TIMEOUT ?? 30000),
} as const;
